import React from "react";
import "./StyleGuide.css"
import "../misc/headerNav.css";
import logo from "../Component/images/logo.png"
import homeButton from "../Component/images/home.png"
import settingsButton from "../Component/images/settings.png"
import AvatarDropdown from "../misc/avatarDropdown"
import errorStatus2 from "../assets/Error2.png";
import magnifyingGlass from "../assets/glass.png"
import { Link } from 'react-router-dom'
export default class StyleGuide extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          isMHidden: true,
          isSizeMHidden: true,
          isColorMHidden: true,
          isFormMHidden: true,
          isArchMHidden: true,
          isLeadMHidden: true,
          isArtMHidden: true,
          isVotingMHidden: true,
          isAUMHidden: true,
          isStoriesMHidden: true,
          issetMHidden:true,
          isPPMHidden:true,
          isHPMHidden:true,
          isHBMHidden:true,
          isLayoutMHidden:true,
          isPopModMHidden: true,
          isErrorMHidden:true,
          isMethodsMHidden:true,
          isHidden: true,
          isWebHidden: true,
          isSizeHidden: true,
          isColorHidden: true,
          isFormHidden: true,
          isArchHidden: true,
          isLeadHidden: true,
          isArtHidden: true,
          isVotingHidden: true,
          isAUHidden: true,
          isStoriesHidden: true,
          issetHidden:true,
          isPPHidden:true,
          isHPHidden:true,
          isHBHidden:true,
          isLayoutHidden:true,
          isPopModHidden: true,
          isErrorHidden:true,
          isMethodsHidden:true,
          isMobileHidden:true,
          isButtonsMHidden:true
        }
        this.fieldChangeHandler.bind(this)
      }
      fieldChangeHandler(field, e) {
        this.setState({
          [field]: e.target.value
        })
      }
    toggleFontsHidden () {
        this.setState({
          isHidden: !this.state.isHidden
        })
      }
      toggleWebHidden () {
        this.setState({
          isWebHidden: !this.state.isWebHidden
        })
      }
      toggleSizesHidden () {
        this.setState({
          isSizeHidden: !this.state.isSizeHidden
        })
      }
      toggleColorsHidden () {
        this.setState({
          isColorHidden: !this.state.isColorHidden
        })
      }
      toggleFormsHidden () {
        this.setState({
          isFormHidden: !this.state.isFormHidden
        })
      }
      toggleHBHidden () {
        this.setState({
          isHBHidden: !this.state.isHBHidden
        })
      }
      toggleHPHidden () {
        this.setState({
          isHPHidden: !this.state.isHPHidden
        })
      }
      togglePPHidden () {
        this.setState({
          isPPHidden: !this.state.isPPHidden
        })
      }
      togglesetHidden () {
        this.setState({
          issetHidden: !this.state.issetHidden
        })
      }
      toggleStoriesHidden () {
        this.setState({
          isStoriesHidden: !this.state.isStoriesHidden
        })
      }
      toggleAUHidden () {
        this.setState({
          isAUHidden: !this.state.isAUHidden
        })
      }
      toggleVotingHidden () {
        this.setState({
          isVotingHidden: !this.state.isVotingHidden
        })
      }
      toggleArtHidden () {
        this.setState({
          isArtHidden: !this.state.isArtHidden
        })
      }
      toggleLeadHidden () {
        this.setState({
          isLeadHidden: !this.state.isLeadHidden
        })
      }
      toggleArchHidden () {
        this.setState({
          isArchHidden: !this.state.isArchHidden
        })
      }
      toggleLayoutHidden () {
        this.setState({
          isLayoutHidden: !this.state.isLayoutHidden
        })
      }
      togglePopModHidden () {
        this.setState({
          isPopModHidden: !this.state.isPopModHidden
        })
      }
      toggleErrorHidden () {
        this.setState({
          isErrorHidden: !this.state.isErrorHidden
        })
      }
      toggleMethodsHidden () {
        this.setState({
          isMethodsHidden: !this.state.isMethodsHidden
        })
      }
      toggleMobileHidden() {
        this.setState({
          isMobileHidden: !this.state.isMobileHidden
        })
      }
      toggleFontsMHidden () {
        this.setState({
          isMHidden: !this.state.isMHidden
        })
      }
      toggleSizesMHidden () {
        this.setState({
          isSizeMHidden: !this.state.isSizeMHidden
        })
      }
      toggleColorsMHidden () {
        this.setState({
          isColorMHidden: !this.state.isColorMHidden
        })
      }
      toggleFormsMHidden () {
        this.setState({
          isFormMHidden: !this.state.isFormMHidden
        })
      }
      toggleHBMHidden () {
        this.setState({
          isHBMHidden: !this.state.isHBMHidden
        })
      }
      toggleHPMHidden () {
        this.setState({
          isHPMHidden: !this.state.isHPMHidden
        })
      }
      togglePPMHidden () {
        this.setState({
          isPPMHidden: !this.state.isPPMHidden
        })
      }
      togglesetMHidden () {
        this.setState({
          issetMHidden: !this.state.issetMHidden
        })
      }
      toggleStoriesMHidden () {
        this.setState({
          isStoriesMHidden: !this.state.isStoriesMHidden
        })
      }
      toggleAUMHidden () {
        this.setState({
          isAUMHidden: !this.state.isAUMHidden
        })
      }
      toggleVotingMHidden () {
        this.setState({
          isVotingMHidden: !this.state.isVotingMHidden
        })
      }
      toggleArtMHidden () {
        this.setState({
          isArtMHidden: !this.state.isArtMHidden
        })
      }
      toggleLeadMHidden () {
        this.setState({
          isLeadMHidden: !this.state.isLeadMHidden
        })
      }
      toggleArchMHidden () {
        this.setState({
          isArchMHidden: !this.state.isArchMHidden
        })
      }
      toggleLayoutMHidden () {
        this.setState({
          isLayoutMHidden: !this.state.isLayoutMHidden
        })
      }
      togglePopModMHidden () {
        this.setState({
          isPopModMHidden: !this.state.isPopModMHidden
        })
      }
      toggleErrorMHidden () {
        this.setState({
          isErrorMHidden: !this.state.isErrorMHidden
        })
      }
      toggleMethodsMHidden () {
        this.setState({
          isMethodsMHidden: !this.state.isMethodsMHidden
        })
      }
      toggleButtonsMHidden () {
        this.setState({
          isButtonsMHidden: !this.state.isButtonsMHidden
        })
      }
    render() {
        return (
          <div>
          <div className="headerBar">
                
                <Link to="/" style={{ textDecoration: 'none' }}>
                <div className="headerLeft">
                    <img className="logo" src={logo} alt="logo" height={41} width={53}></img>
                    <div className="webname">Crafting Cannon</div>
                </div>
                </Link>

                <div className="headerRight">
                    <Link to="/">
                        <img className="homebutton" src={homeButton} alt="home button"></img>
                    </Link>
                    <Link to="/settings">
                        <img className="settingsbutton" src={settingsButton} alt="settings button"></img>
                    </Link>
                    <AvatarDropdown />
                </div>

            </div>
            <div className="styleguide">
              
                <ul className = "webormob">
                    <li className = "webtitle" onClick={this.toggleWebHidden.bind(this)}>Web</li>
                    {!this.state.isWebHidden &&
                <ul className="styleList">
                    <li onClick={this.toggleFontsHidden.bind(this)}>Fonts</li>
                    {!this.state.isHidden &&
                    <ul className = "fontsUsed">
                        <li className="storyFont"><div className="storyFont">For the text of stories, use Source Serif Pro at size 16px by</div><div className="storyFont">.storyFont&#123;</div>
  <div className="storyFont" style={{textIndent: "30px"}}>font-family: "Source Serif Pro";</div>
  <div className="storyFont" style={{textIndent: "30px"}}>font-size: 16px;</div>
  <div className="storyFont">&#125;</div></li>
                        <li className="otherFont">Otherwise, the default text is Roboto with varying sizes (see next section)</li>
                    </ul>
    }
                    <li onClick={this.toggleSizesHidden.bind(this)}>Sizes</li>
                        {!this.state.isSizeHidden &&
                        <ul className = "sizeInfo">
                            <li onClick={this.toggleFormsHidden.bind(this)}>Handling Forms (Login, Signup, Reset/Set New Password)</li>
                            {!this.state.isFormHidden &&<ul className = "wah">
                              <li>Width: 30%; Min-Width: 325px; Max-Width: 525px</li>
                              <li>Height: based on contents/padding of form, do not explicitly declare</li>
                              <li>Header Text Font-Size: 28px</li>
                              <li>Input Box Header Text Font-Size: large</li>
                              <li>Input Box Size: Width - 100%; Height - 40px</li>
                              <li>Input Box Font Size: large</li>
                              <li>Buttons: Width - 25%; Height - 40px</li>
                            </ul>}
                            <li onClick={this.toggleHBHidden.bind(this)}>Header/Navigation Bar</li>
                            {!this.state.isHBHidden &&<ul className = "wah">
                              <li>Height: 76px</li>
                              <li>Crafting Canon Icon: Width - 53px; Height - 41px</li>
                              <li>Crafting Canon Text Font Size: 30px</li>
                              <li>Search Bar: Width - 30%; Height - 41px</li>
                              <li>Home and Settings icons: Width - 29px; Height - 29px</li>
                              <li>Profile Picture (Dropdown Button): Width - 53px; Height - 53px;</li>
                              <li>Dropdown Menu Size: Width - 156px;</li>
                              <li>Dropdown Menu Options Text Font Size: 16px</li>
                              </ul>}
                            <li onClick={this.toggleStoriesHidden.bind(this)}>Stories</li>
                            {!this.state.isStoriesHidden &&<ul className = "wah">
                              <li>Story Box Size: 54.5vw</li>
                              <li>Story Box Header Size: Width - 100%; Height - 52px</li>
                              <li>Story Box Author PFP size: Width - 34px; Height - 34px</li>
                              <li>Story Box Author Username Font Size: 17px</li>
                              <li>Deadline Icon Size: Height - 15px</li>
                              <li>Deadline Text Font Size: 13px</li>
                              <li>Story Title Font Size: 22px</li>
                              <li>Story Body Font Size: 16px</li>
                              <li>Like Value, Comment Value, Share, Report and Contribute! Text Font Size: 13px</li>
                              <li>Like, Comment, Share, and Report Icon Size: Height - 15px</li>
                              <li>Contribute Icon Size: Width - 20px; Height - 15px</li>
                              <li>Dropdown Sort By Label Font Size: medium</li>
                              <li>Dropdown Option Box Size: Width - 175px</li>
                              <li>Dropdown Options Text Font Size: medium</li>
                              </ul>}
                            <li onClick={this.toggleHPHidden.bind(this)}>Homepage</li>
                            {!this.state.isHPHidden &&<ul className = "wah">
                              <li>Create a Story Box Size: Width - 54.5vw</li>
                              <li>Create a Story User Profile Picture Size: Width - 53px; Height - 53px</li>
                              <li>Create a Story Input Box Size: Width - 88%; Height - 41px</li>
                              <li>Create a Story Text Font Size: 17px</li>
                              <li>Dropdown Sort By Label Font Size: medium</li>
                              <li>Dropdown Option Box Size: Width - 175px</li>
                              <li>Dropdown Options Text Font Size: medium</li>
                              <li>Archived Stories Button Size: Width - 60%; Height - 52px</li>
                              <li>Archived Stories Text Font Size: large;</li>
                              <li>Leaderboard Box Size: Width - 60%; Min-Width - 195px</li>
                              <li>Leaderboard Box Header Size: Width - 100%; Height - 52px</li>
                              <li>Leaderboard Title: large</li>
                              <li>Leaderboard User Placement Box Size: Height - 50px</li>
                              <li>Leaderboard User Placement and Username Text Font Size: 17px</li>
                              <li>Leaderboard User Profile Picture Size: Width - 35px; Height - 35px</li>
                              <li>Leaderboard View All Button Size: Width - fit-content; Height - 30px</li>
                              <li>Leaderboard View All Text Font Size: small</li>
                              </ul>}
                            <li onClick={this.togglePPHidden.bind(this)}>Profile Page</li>
                            {!this.state.isPPHidden &&<ul className = "wah">
                              <li>Width: max(30rem, 40%)</li>
                              <li>Height: based on contents/padding, do not explicitly declare</li>
                              <li>User's Profile Picture: Width - 10rem; Height - 10rem</li>
                              <li>Username Text Font Size: 22px</li>
                              <li>Follow/Unfollow Button Size: Width - 119px</li>
                              <li>Block/Unblock Button Size: Width - fit-content</li>
                              <li>Follow/Unfollow and Block/Unblock Buttons Text Font Size: 16px</li>
                              <li>Tab Button Size: Width - 5rem; Height - 2rem</li>
                              <li>Tab Button Text Font Size: calc(10px + 2vmin)</li>
                              <li>About Me Body Text Font Size: 16px</li>
                              <li>Story Box Size: Width - 85%</li>
                              <li>Story Image Size: Width - 100%; Max-Width -  100px; Max-Height - 100px</li>
                              <li>Story Title Font Size: 28px</li>
                              <li>Story Like and Comment Buttons Size: Max-Width - 15px; Max-Height - 15px</li>
                              <li>Story Like and Comment Counts Font Size: 16px</li>
                              <li>Follower/Following Box Size: Width - 30%; Height - 175px</li>
                              <li>Follower/Following Profile Picture: Width - 100px; Height - 100px;</li>
                              </ul>}
                            <li onClick={this.togglesetHidden.bind(this)}>Account Settings Page</li>
                            {!this.state.issetHidden &&<ul className = "wah">
                              <li>Settings Box: Width - 597px; Height - 60%</li>
                              <li>Account Settings Text Font Size: 22px</li>
                              <li>Profile Picture: Width - 108px; Height - 108px</li>
                              <li>Change Profile Picture, Username, Email, Password, and Change Text Font Size: 13px</li>
                              <li>Delete Button Size: Height - 100%</li>
                              <li>Delete Button Text Font Size: 16px</li>
                              <li>Input Box Size: Width - 535px;</li>
                              <li>Input Box Text Font Size: 16px</li>
                              </ul>}
                            <li onClick={this.toggleAUHidden.bind(this)}>Commenter's Section</li>
                            {!this.state.isAUHidden &&<ul className = "wah">
                              <li>Commenters Profile Picture Size: Width - 34px; Height - 34px</li>
                              <li>Add a comment... Box Size: Width - 50.3vw; Height - 7.6%</li>
                              <li>No Comments Found Text Font Size: calc(10px + 2vmin);</li>
                              <li>Comments and Sort By Text Font Size: medium</li>
                              <li>Dropdown Option Box Size: Width - 175px</li>
                              <li>Dropdown Options Text Font Size: medium</li>
                              <li>Comments Box Size: Width - 50vw</li>
                              <li>Comments User Profile Picture Size: Width - 34px; Height - 34px</li>
                              <li>Comments Username Font Size: 13px</li>
                              <li>Comments Content Font Size: 12px</li>
                              <li>Comments Report Icon Size: Height - 15px</li>
                              <li>Comments Report Text Size: 13px</li>
                              <li>View More Comments Text Font Size: 76%</li>
                              </ul>}
                            <li onClick={this.toggleVotingHidden.bind(this)}>Voting Page</li>
                            {!this.state.isVotingHidden &&<ul className = "wah">
                              <li>The story that is being continued follows the same sizing as other stories besides the box and header: Width - 100%</li>
                              <li>Create Contribution! Button Size: 60%; Min-Width - 195px; Height - 52px; Min-Height - 28px</li>
                              <li>Create Contribution! Text Font Size: large</li>
                              <li>User Contributions Box Size: Width - 100%</li>
                              <li>User Contributions Header Size: Width - 100%; Height - 52px</li>
                              <li>User Contriutions Header Font Size: 17px</li>
                              <li>User Contributions Title Font Size: 22px</li>
                              <li>User Contributions Story Font Size: 16px</li>
                              <li>User Contributions Profile Picture Size: Width - 34px; Height - 34px</li>
                              <li>Upvote Count Box Size: No sizes explicitly declared</li>
                              <li>Upvote Count Font Size: 17px</li>
                              <li>View All Buttons: Width - fit-content; Height - 30px</li>
                              <li>View All Buttons Text Size: small</li>
                              <li>Vote/Downvote Button(s): No sizes explicitly declared</li>
                              <li>Vote/Downvote Button(s) Font Size: Not explicitly declared</li>
                              <li>Leaderboard is the same as it was on the Homepage</li>
                              <li>Artwork Box Size: Width - 60%</li>
                              <li>Artwork Header Size: No sizes explicitly declared</li>
                              <li>Artwork Text Font Size: large</li>
                              <li>Artwork Image Size: Width - 100px; Height - 100px</li>
                              <li>Sort By and Sort By Options Text Font Size: medium</li>
                              <li>Dropdown Option Box Size: Width - 175px</li>
                              </ul>}
                            <li onClick={this.toggleArtHidden.bind(this)}>Artwork Page</li>
                            {!this.state.isArtHidden &&<ul className = "wah">
                              <li>Artwork Box Size: Width - 54.5vw; Height - Should flex with amount of art, do not explicitly declare</li>
                              <li>Artwork Text Font Size: 22px</li>
                              <li>Artwork Image Size: Height - 200px</li>
                              <li>Artwork Upload Image Button Size: Width - 100%</li>
                              <li>Artwork Upload Image Font Text Size: large</li>
                              <li>Leaderboard is the same as it was on the Homepage</li>
                              </ul>}
                            <li onClick={this.toggleLeadHidden.bind(this)}>Leaderboard Page</li>
                            {!this.state.isLeadHidden &&<ul className = "wah">
                              <li>Leaderboard Box Size: Width - 75%; Height - 100%</li>
                              <li>Leaderboard Font Size: 125%</li>
                              <li>Position Text Font Size: calc(10px + 2vmin)</li>
                              <li>Leaderboard Position Box Size: Height - 100px</li>
                              <li>Leaderboard User Profile Picture Size: Width - 75px; Height - 75px</li>
                              <li>Leaderboard Username Font Size: 20px</li>
                              <li>Leaderboard Like Icon Size: Width - 25px; Height - 25px</li>
                              <li>Leaderboard Like Count Text Font Size: calc(10px + 2vmin)</li>
                              <li>Leaderboard Top 3 Crown Icon: Width - 55px; Height - 55px</li>
                              </ul>}
                            <li onClick={this.toggleArchHidden.bind(this)}>Archived Page</li>
                            {!this.state.isArchHidden &&<ul className = "wah">
                              <li>Archived Stories will follow precedent set in Stories section.</li>
                              <li>Archived Stories Sort By Text Font Size: 13px</li>
                              <li>Archived Stories Dropdown Option Selected Size: Width - 217px; Height - 24px</li>
                              <li>Archived Stories Dropdown Option Selecting Size: Width - 217px; Height - 85px</li>
                              <li>Archived Stories Dropdown Options Text Font Size: 13px</li>
                              </ul>}
                            </ul>
                        }
                    <li onClick = {this.toggleLayoutHidden.bind(this)}>Layout and Navigation Templates</li>
                    { !this.state.isLayoutHidden &&<ul className = "Layout">
                      <li>The content of focus will be in a box/container, against a gray background that separates groupings</li>
                      <li>Header/Nav Bar at the top of each page, extending the full width of the page</li>
                      <li>All blue buttons with white text have rounded edges.</li>
                      <li>Groupings on a given page are separated by a combination of the gray background and proximity.</li>
                      </ul>}
                    <li onClick={this.toggleColorsHidden.bind(this)}>Color Palette</li>
                    {!this.state.isColorHidden &&
                    <ul className = "palette">
                        <li>#54b6b0 <div className="Rect" style={{backgroundColor:"#54b6b0"}}></div></li>
                        <li>#e5e5e5 <div className="Rect" style={{backgroundColor:"#e5e5e5"}}></div></li>
                        <li>#969696 <div className="Rect" style={{backgroundColor:"#969696"}}></div></li>
                        <li>#5f6265 <div className="Rect" style={{backgroundColor:"#5f6265"}}></div></li>
                        <li>#585858 <div className="Rect" style={{backgroundColor:"#585858"}}></div></li>
                        <li>#2e2e2e <div className="Rect" style={{backgroundColor:"#2e2e2e"}}></div></li>
                        <li>#121212 <div className="Rect" style={{backgroundColor:"#121212"}}></div></li>
                        <li>#1f1f1f <div className="Rect" style={{backgroundColor:"#1f1f1f"}}></div></li>
                        <li>#ff0000 <div className="Rect" style={{backgroundColor:"red"}}></div></li>
                    </ul>}
                    <li onClick = {this.togglePopModHidden.bind(this)}>Popups/Modals</li>
                    {!this.state.isPopModHidden && <ul className = "popmod">
                      <li>Centered horizontally on the page.</li>
                      <li>Use your mouse to click into and/or the tab key to enter into a text area.</li>
                      <li>Click a button or hit the enter key once all fields are filled in.</li>
                      <li>There should be a cancel button so people may escape out of it if desired.</li>
                      <li>The cancel button should be the right-most button along the bottom of the popup.</li>
                      <li>Translucent background used to bring more focus to the popup.</li>
                      </ul>}
                    <li onClick = {this.toggleErrorHidden.bind(this)}>Treatment of Error Conditions</li>
                    {!this.state.isErrorHidden && <ul className = "err">
                      <li>When there is incorrect/invalid input (example: email or password), a message will be displayed to alert the user in white text with a red background, also containing the <img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /> icon.</li>
                      </ul>}
                    <li onClick = {this.toggleMethodsHidden.bind(this)}>Methods for Inline Help</li>
                    {!this.state.isMethodsHidden && <ul className = "methods">
                      <li>There are currently none given at this time.</li>
                      </ul>}
                    </ul>
                    }
                    <li className = "webtitle" onClick={this.toggleMobileHidden.bind(this)}>Mobile</li>
                    {!this.state.isMobileHidden &&
                    <ul className="styleList">
                    <li onClick={this.toggleFontsMHidden.bind(this)}>Fonts</li>
                    {!this.state.isMHidden &&
                    <ul className = "fontsUsed">
                        <li className="storyFont"><div className="storyFont">For the text of stories, use Source Serif Pro at size 16px by</div><div className="storyFont">.storyFont&#123;</div>
  <div className="storyFont" style={{textIndent: "30px"}}>font-family: "Source Serif Pro";</div>
  <div className="storyFont" style={{textIndent: "30px"}}>font-size: 16px;</div>
  <div className="storyFont">&#125;</div></li>
                        <li className="otherFont">Otherwise, the default text is Roboto with varying sizes (see next section)</li>
                    </ul>
    }
                    <li onClick={this.toggleSizesMHidden.bind(this)}>Sizes</li>
                        {!this.state.isSizeMHidden &&
                        <ul className = "sizeInfo">
                            <li onClick={this.toggleFormsMHidden.bind(this)}>Handling Forms (Login, Signup, Reset/Set New Password)</li>
                            {!this.state.isFormMHidden &&<ul className = "wah">
                              <li>Width: 30%; Min-Width: 325px; Max-Width: 525px</li>
                              <li>Height: based on contents/padding of form, do not explicitly declare</li>
                              <li>Header Text Font-Size: 28px</li>
                              <li>Input Box Header Text Font-Size: large</li>
                              <li>Input Box Size: Width - 100%; Height - 40px</li>
                              <li>Input Box Font Size: large</li>
                              <li>Buttons: Width - 25%; Height - 40px</li>
                            </ul>}
                            <li onClick={this.toggleHBMHidden.bind(this)}>Header/Navigation Bar</li>
                            {!this.state.isHBMHidden &&<ul className = "wah">
                              <li>Height: 76px</li>
                              <li>Crafting Canon Icon: Width - 53px; Height - 41px</li>
                              <li>Search Bar: Width - 52%; Height - 41px</li>
                              <li>Profile Picture (Dropdown Button): Width - 53px; Height - 53px;</li>
                              <li>Dropdown Menu Size: Width - 180px;</li>
                              <li>Dropdown Menu Options Text Font Size: 16px</li>
                              </ul>}
                              <li onClick={this.toggleStoriesMHidden.bind(this)}>Stories</li>
                            {!this.state.isStoriesMHidden &&<ul className = "wah">
                              <li>Story Box Size: Width - 95%;</li>
                              <li>Story Box Header Size: Width - 100%; Height - 52px</li>
                              <li>Story Box Author PFP size: Width - 34px; Height - 34px</li>
                              <li>Story Box Author Username Font Size: 17px</li>
                              <li>Deadline Icon Size: Height - 15px</li>
                              <li>Deadline Text Font Size: 13px</li>
                              <li>Story Title Font Size: 22px</li>
                              <li>Story Body Font Size: 16px</li>
                              <li>Like Value, Comment Value, Share, Report and Contribute Text Font Size: 13px</li>
                              <li>Like, Comment, Share, and Report Icon Size: Height - 15px</li>
                              <li>Contribute Icon Size: Width - 20px; Height - 15px</li>
                              <li>Dropdown Option Box Size: Width - 175px;</li>
                              <li>Dropdown Options Text Font Size: medium</li>
                              </ul>}
                            <li onClick={this.toggleHPMHidden.bind(this)}>Homepage</li>
                            {!this.state.isHPMHidden &&<ul className = "wah">
                              <li>Create a Story Box Size: Width - 95%;</li>
                              <li>Create a Story User Profile Picture Size: Width - 53px; Height - 53px</li>
                              <li>Create a Story Input Box Size: Width - 88%; Height - 41px</li>
                              <li>Create a Story Text Font Size: 17px</li>
                              <li>Sort By and Sort By Options Text Font Size: medium</li>
                              <li>Sort By Options Dropdown Box Size: Width - 175px</li>
                              </ul>}
                            <li onClick={this.togglePPMHidden.bind(this)}>Profile Page</li>
                            {!this.state.isPPMHidden &&<ul className = "wah">
                              <li>Width: 100%</li>
                              <li>Height: based on contents/padding, do not explicitly declare</li>
                              <li>User's Profile Picture: Width - 10rem; Height - 10rem</li>
                              <li>Username Text Font Size: 22px</li>
                              <li>Follow/Unfollow Button Size: Width - 119px</li>
                              <li>Follow/Unfollow and Block/Unblock Button Font Size: 16px</li>
                              <li>Block/Unblock Button Size: Width - fit-content</li>
                              <li>Tab Button Size: 5rem; Height - 2rem</li>
                              <li>Tab Button Text Font Size: calc(10px + 2vmin)</li>
                              <li>About Me Body Text Font Size: 16px</li>
                              <li>Story Box Size: Width - 85%</li>
                              <li>Story Image Size: Width - 100%; Max-Width - 100px; Max-Height - 100px</li>
                              <li>Story Title Font Size: 28px</li>
                              <li>Story Like and Comment Buttons Size: Max-Width - 15px; Max-Height - 15px</li>
                              <li>Story Like and Comment Counts Font Size: 16px</li>
                              <li>Follower/Following Box Size: Width - 30%; Height - 175px</li>
                              <li>Follower/Following Profile Picture: Width - 100px; Height - 100px</li>
                              </ul>}
                            <li onClick={this.togglesetMHidden.bind(this)}>Account Settings Page</li>
                            {!this.state.issetMHidden &&<ul className = "wah">
                              <li>Settings Box: Width - 100%; Height - 100%</li>
                              <li>Account Settings Text Font Size: 22px</li>
                              <li>Profile Picture: Width - 108px; Height - 108px</li>
                              <li>Change Profile Picture, Username, Email, Password, and Change Text Font Size: 13px</li>
                              <li>Delete Button Size: Height - 100%</li>
                              <li>Delete Button Text Font Size: 16px</li>
                              <li>Input Box Size: Width - 535px; Max-Width - 85vw</li>
                              <li>Input Box Text Font Size: 16px</li>
                              </ul>}
                            <li onClick={this.toggleAUMHidden.bind(this)}>Commenter's Section</li>
                            {!this.state.isAUMHidden &&<ul className = "wah">
                              <li>Commenters Profile Picture Size: Width - 34px; Height - 34px</li>
                              <li>Add a comment... Box Size: Width - 84vw; Height - 7.6%</li>
                              <li>No Comments Found Text Font Size: calc(10px + 2vmin)</li>
                              <li>Comments and Sort By Text Font Size: medium</li>
                              <li>Dropdown Option Box Size: Width - 175px</li>
                              <li>Dropdown Options Text Font Size: medium</li>
                              <li>Comments Box Size: Width - 100%</li>
                              <li>Comments User Profile Picture Size: Width - 34px; Height - 34px</li>
                              <li>Comments Username Font Size: 13px</li>
                              <li>Comments Content Font Size: 12px</li>
                              <li>Comments Report Icon Size: Height - 15px</li>
                              <li>Comments Report Text Size: 13px</li>
                              <li>View More Comments Text Font Size: 76%</li>
                              </ul>}
                            <li onClick={this.toggleVotingMHidden.bind(this)}>Voting Page</li>
                            {!this.state.isVotingMHidden &&<ul className = "wah">
                            <li>The story that is being continued follows the same sizing as other stories besides the box and header: Width - 100%</li>
                              <li>User Contributions Box Size: Width - 100%</li>
                              <li>User Contributions Header Size: Width - 100%; Height - 52px</li>
                              <li>User Contriutions Header Font Size: 17px</li>
                              <li>User Contributions Title Font Size: 22px</li>
                              <li>User Contributions Story Font Size: 16px</li>
                              <li>User Contributions Profile Picture Size: Width - 34px; Height - 34px</li>
                              <li>Sort By and Sort By Options Text Font Size: medium</li>
                              <li>Dropdown Option Box Size: Width - 175px</li>
                              </ul>}
                            <li onClick={this.toggleArtMHidden.bind(this)}>Artwork Page</li>
                            {!this.state.isArtMHidden &&<ul className = "wah">
                              <li>Artwork Box Size: Width - 100%</li>
                              <li>Artwork Text Font Size: 22px</li>
                              <li>Artwork Image Size: Height - 26vw</li>
                              </ul>}
                            <li onClick={this.toggleLeadMHidden.bind(this)}>Leaderboard Page</li>
                            {!this.state.isLeadMHidden &&<ul className = "wah">
                            <li>Leaderboard Box Size: Width - 100%; Height - 100%</li>
                              <li>Leaderboard Text Font Size: 125%</li>
                              <li>Position Text Font Size: calc(10px + 2vmin)</li>
                              <li>Leaderboard Position Box Size: Height - 100px</li>
                              <li>Leaderboard User Profile Picture Size: Width - 75px; Height - 75px</li>
                              <li>Leaderboard Username Text Font Size: 17px</li>
                              <li>Leaderboard Like Icon Size: Width - 25px; Height - 25px</li>
                              <li>Leaderboard Like Count Text Font Size: calc(10px + 2vmin)</li>
                              <li>Leaderboard Top 3 Crown Icon: Width - 55px; Height - 55px</li>
                              </ul>}
                            <li onClick={this.toggleArchMHidden.bind(this)}>Archived Page</li>
                            {!this.state.isArchMHidden &&<ul className = "wah">
                              <li>Archived Stories will follow precedent set in Stories section.</li>
                              </ul>}
                            </ul>
                        }
                    <li onClick = {this.toggleLayoutMHidden.bind(this)}>Layout and Navigation Templates</li>
                    { !this.state.isLayoutMHidden &&<ul className = "Layout">
                      <li>The content of focus will either be in a box/container, against a gray background that separates groupings, or it will take up the whole screen</li>
                      <li>Header/Nav Bar at the top of each page, extending the full width of the page</li>
                      <li>All blue buttons with white text have rounded edges.</li> 
                      <li>By clicking the Profile Picture at the top right at any time, all of the different pages can be accessed.</li>
                      <li>Hitting the back arrow at the top left of the page will bring you to the page you were previously on.</li>
                    </ul>}
                    <li onClick={this.toggleColorsMHidden.bind(this)}>Color Palette</li>
                    {!this.state.isColorMHidden &&
                    <ul className = "palette">
                        <li>#54b6b0 <div className="Rect" style={{backgroundColor:"#54b6b0"}}></div></li>
                        <li>#e5e5e5 <div className="Rect" style={{backgroundColor:"#e5e5e5"}}></div></li>
                        <li>#969696 <div className="Rect" style={{backgroundColor:"#969696"}}></div></li>
                        <li>#5f6265 <div className="Rect" style={{backgroundColor:"#5f6265"}}></div></li>
                        <li>#585858 <div className="Rect" style={{backgroundColor:"#585858"}}></div></li>
                        <li>#2e2e2e <div className="Rect" style={{backgroundColor:"#2e2e2e"}}></div></li>
                        <li>#121212 <div className="Rect" style={{backgroundColor:"#121212"}}></div></li>
                        <li>#1f1f1f <div className="Rect" style={{backgroundColor:"#1f1f1f"}}></div></li>
                        <li>#ff0000 <div className="Rect" style={{backgroundColor:"red"}}></div></li>
                    </ul>}
                    <li onClick = {this.togglePopModMHidden.bind(this)}>Popups/Modals</li>
                    {!this.state.isPopModMHidden && <ul className = "popmod">
                      <li>Centered horizontally on the page.</li>
                      <li>Tap into the whitespace of the text area.</li>
                      <li>Click a button once all fields are filled in.</li>
                      <li>There should be a cancel button so people may escape out of it if desired.</li>
                      <li>The cancel button should be the right-most button along the bottom of the popup.</li>
                      <li>Translucent background used to bring more focus to the popup.</li>
                      </ul>}
                    <li onClick = {this.toggleErrorMHidden.bind(this)}>Treatment of Error Conditions</li>
                    {!this.state.isErrorMHidden && <ul className = "err">
                    <li>When there is incorrect/invalid input (example: email or password), a message will be displayed to alert the user in white text with a red background, also containing the <img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /> icon.</li>
                      </ul>}
                    <li onClick = {this.toggleMethodsMHidden.bind(this)}>Methods for Inline Help</li>
                    {!this.state.isMethodsMHidden && <ul className = "methods">
                      <li>There are currently none given at this time.</li>
                      </ul>}
                    </ul>}
                </ul>
            </div>
            </div>
        )
    }
}